import { FC } from "react";

import Desktop from "../../../../assets/images/content/introduction/become-a-member/become-a-member-desktop.png";
import Mobile from "../../../../assets/images/content/introduction/become-a-member/become-a-member-mobile.png";

const BecomeAMember: FC = () => {
	return (
		<div className="flex flex-col">
			<img
				className="hidden md:block w-3/4 self-center"
				src={Desktop}
			/>
			<img
				className="block md:hidden w-full max-w-sm self-center"
				src={Mobile}
			/>
		</div>
	);
};

export { BecomeAMember };